import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { Company } from "@/types";

interface CompanyFilterSelectProps {
  value: string;
  onChange: (value: string) => void;
  companies: Company[];
  className?: string;
}

export function CompanyFilterSelect({
  value,
  onChange,
  companies,
  className = "w-[220px]",
}: CompanyFilterSelectProps) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={className}>
        <SelectValue placeholder="Filtrar por compañía" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">Todas las compañías</SelectItem>
        {companies.map((company) => (
          <SelectItem key={company.id} value={String(company.id)}>
            {company.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
